import {
  Box,
  ImageList,
  ImageListItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
} from "@mui/material";
import UTextField from "../../components/mui/UTextField";
import { useRef } from "react";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { useState } from "react";
import { getAPI } from "../../services/commonService";

// API
import { fni18n } from "../../services/commonService";

import { makeStyles } from "@material-ui/core/styles";
import { theme } from "../../assets/themes";
import UTable from "../../components/mui/UTable";
import { API } from "../../config";

const imageColumns = [
  {
    field: "payload",
    headerName: "Payload",
    width: 80,
    headerAlign: "center",
    align: "center",
  },
];

//export default function HistPopUpPage({ history }) {
export default function PmsLogPopUpPage(props) {
  const data = props.data;
  const printRef = useRef();
  const [detailInfo, setDetailInfo] = useState({
    storeCd: "",
    machId: "",
    trnsctDt: "",
    trnsctSeq: "",
    jrnlMsg: "",
    machIp: "",
    machPort: "",
    trnsctKndCd: "",
    trnsctKndCdnm: "",
    userId: "",
    userNm: "",
    grpCd: "",
    grpNm: "",
  });

  const [itemData, setItemData] = useState([
    {
      id: "0",
      img: "1",
      pos: "",
      title: "",
    },
  ]);

  const useStyles = makeStyles({
    table: {
      "& .MuiTableCell-root": {
        border: "1px solid #EAEAEA",
        borderTop: "1px solid #EAEAEA",
      },
    },
    header: {
      fontWeight: "bold",
      "& .MuiTableCell-root": {
        // width:195,
      },
    },
    cellTitle: {
      backgroundColor: theme.custom.appbarBgColor,
    },
    cell: {
      padding: 5,
    },
  });
  const classes = useStyles();
  //화면 로드 시
  useEffect(() => {}, []);

  //
  const dateFormmater = (yyyymmdd) => {
    let date = yyyymmdd;
    /*if (yyyymmdd.length > 7) {
      const year = yyyymmdd.substring(0, 4);
      const month = yyyymmdd.substring(4, 6);
      const day = yyyymmdd.substring(6, 8);
      const hh = yyyymmdd.substring(8, 10);
      const mm = yyyymmdd.substring(10, 12);
      const ss = yyyymmdd.substring(12, 14);
      date = year + "-" + month + "-" + day + " " + hh + ":" + mm + ":" + ss;
    }*/
    return date;
  };
  const trnsctDt = dateFormmater(data.recvDate);

  return (
    <div className="pop-container">
      <Box className="contents">
        <Box>
          <TableContainer className="table-container">
            <Table className="table" size="small">
              <TableBody>
                <TableRow className="table-row-header">
                  <TableCell className="table-cell-title">{fni18n("일자")}</TableCell>
                  <TableCell className="table-cell">
                    {/* 거래일자 */}
                    <UTextField
                      id="trnsctDt"
                      name="trnsctDt"
                      defaultValue={trnsctDt}
                      disabled={true}
                    />
                  </TableCell>
                  <TableCell className="table-cell-title">{fni18n("브랜드번호")}</TableCell>
                  <TableCell className="table-cell">
                    {/* 점번 */}
                    <UTextField
                      id="branch"
                      name="storeCd"
                      defaultValue={data.storeCd}
                      disabled={true}
                    />
                  </TableCell>
                  <TableCell className="table-cell-title">
                    {/* {"Terminal ID"} */}
                    {fni18n("기기번호")}
                  </TableCell>
                  <TableCell className="table-cell">
                    {/* 기번 */}
                    <UTextField
                      id="machId"
                      name="machId"
                      defaultValue={data.termId}
                      disabled={true}
                    />
                  </TableCell>
                </TableRow>
                <TableRow className="table-row-header">
                  <TableCell className="table-cell-title">
                    {/* {"Machine Seq"} */}
                    {fni18n("기기일련번호")}
                  </TableCell>
                  <TableCell className="table-cell">
                    {/* 브랜드 */}
                    <UTextField
                      id="machineSeq"
                      name="machineSeq"
                      defaultValue={data.machineSeq}
                      disabled={true}
                    />
                  </TableCell>
                  <TableCell className="table-cell-title">
                    {/* {"ACNT CD"} */}
                    {fni18n("거래코드")}
                  </TableCell>
                  <TableCell className="table-cell">
                    {/* 거래유형 */}
                    <UTextField
                      id="acntCd"
                      name="acntCd"
                      defaultValue={data.acntCd}
                      disabled={true}
                    />
                  </TableCell>
                  <TableCell className="table-cell-title">{fni18n("GW일련번호")}</TableCell>
                  <TableCell className="table-cell">
                    {/* 거래번호 */}
                    <UTextField
                      id="gwSeq"
                      name="gwSeq"
                      defaultValue={data.gwSeq}
                      disabled={true}
                    />
                  </TableCell>
                </TableRow>
                <TableRow className="table-row-header">
                  <TableCell className="table-cell-title">
                    {/* {"Machine IP"} */}
                    {fni18n("정산기기IP")}
                  </TableCell>
                  <TableCell className="table-cell">
                    {/* 브랜드 */}
                    <UTextField
                      id="machineIp"
                      name="machineIp"
                      defaultValue={data.machineIp}
                      disabled={true}
                    />
                  </TableCell>
                  <TableCell className="table-cell-title">
                    {/* {"Machine Num"} */}
                    {fni18n("기기제조번호")}
                  </TableCell>
                  <TableCell className="table-cell">
                    {/* 거래유형 */}
                    <UTextField
                      id="machineNum"
                      name="machineNum"
                      defaultValue={data.machineNum}
                      disabled={true}
                    />
                  </TableCell>
                  <TableCell className="table-cell-title">
                    {/* {"Machine Num"} */}
                    {fni18n("지연전송")}
                  </TableCell>
                  <TableCell className="table-cell">
                    {/* 거래유형 */}
                    <UTextField
                      id="pendedYn"
                      name="pendedYn"
                      defaultValue={data.pendedYn}
                      disabled={true}
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <div className="search"></div>
        </Box>
        <Box>
          <TableContainer className="table-container">
            <Table className="table" size="small">
              <TableBody>
                <TableRow className="table-row-header">
                  <TableCell className="table-cell-title">
                    {/* {"PMS Result"} */}
                    {fni18n("PMS결과")}
                  </TableCell>
                  <TableCell className="table-cell">
                    {/* 거래일자 */}
                    <UTextField
                      id="result"
                      name="result"
                      defaultValue={data.result}
                      disabled={true}
                    />
                  </TableCell>
                  <TableCell className="table-cell-title">
                    {/* {"ERROR CD"} */}
                    {fni18n("오류번호")}
                  </TableCell>
                  <TableCell className="table-cell">
                    {/* 점번 */}
                    <UTextField
                      id="errCd"
                      name="errCd"
                      defaultValue={data.errCd}
                      disabled={true}
                    />
                  </TableCell>
                  <TableCell className="table-cell-title">
                    {/* {"ERROR MSG"} */}
                    {fni18n("오류상세")}
                  </TableCell>
                  <TableCell className="table-cell">
                    {/* 기번 */}
                    <UTextField
                      id="errMsg"
                      name="errMsg"
                      defaultValue={data.errMsg}
                      disabled={true}
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <div className="search"></div>
        </Box>

        <Box>
          <TableContainer className="table-container">
            <Table className="table" size="small">
              <TableBody>
                <TableRow className="table-row-header">
                  <TableCell className="table-cell-title">
                    {/* {"Payload"} */}
                    {fni18n("전문")}
                  </TableCell>
                </TableRow>
                <TableRow className="table-row-header">
                  <TableCell className="table-cell">
                    <TextField
                      aria-readonly
                      sx={{ width: "100%" }}
                      id="filled-multiline-static"
                      multiline
                      rows={18}
                      variant="filled"
                      size="small"
                      inputProps={{ style: { fontSize: 14, paddingLeft: 50 } }}
                      value={JSON.stringify(
                        JSON.parse(data.payload),
                        null,
                        8
                      ).replaceAll(/(\\n)/g, "\n\t\t\t\t    ")}
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    </div>
  );
}
